module.exports = __webpack_public_path__ + "dist/assets/redesign/ui/components/intro/img/login-logo@2x__c63039cb6bbb8d36b142bdf3e63407d1.png";